import { mapVoluntaryLifeCoverageOptions } from './map-voluntary-life-coverage-options';
import { isCompletePlan } from '../general';
import { LifeSubTypeLike, VoluntaryLifeCategoryDataOptionsContract } from '../../types';

export const VoluntaryAdd: LifeSubTypeLike = {
	isLifeAddDisabled: (state) => isCompletePlan(state),
	getCoverageOptions: (planCategoryDataOption: VoluntaryLifeCategoryDataOptionsContract) => mapVoluntaryLifeCoverageOptions(planCategoryDataOption),
};
